// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"78eba88a","421":"06a2ec8e","741":"78eba88a","849":"9d065ee2"}[chunkId] + ".chunk.css";
};